import React from 'react';
import { Box, Card, Typography, Fade } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { useTranslation } from 'react-i18next';

const RecommendationsEmptyState = () => {
  const { t } = useTranslation();

  return (
    <Fade in timeout={300}>
      <Card
        elevation={0}
        sx={{
          border: '1px solid #e2e8f0',
          borderRadius: 3,
          overflow: 'hidden',
          p: 6,
          textAlign: 'center'
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #667eea15 0%, #764ba215 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            mb: 3
          }}
        >
          <SmartToyIcon sx={{ fontSize: 40, color: '#667eea' }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#2d3748', mb: 1 }}>
          {t('vnstock.recommendations.empty.title')}
        </Typography>
        <Typography variant="body2" sx={{ color: '#718096', maxWidth: 400, margin: '0 auto' }}>
          {t('vnstock.recommendations.empty.description')}
        </Typography>
      </Card>
    </Fade>
  );
};

export default RecommendationsEmptyState;
